// 用户中心-账号信息操作
const UserAccountRouterMap = [
  {
    path: '/',
    component: UserInfo => (require(['@/views/user/userCenter'], UserInfo))
  },
  // 用户详细页面
  {
    path: '/user/user-info',
    component: UserInfo => (require(['@/views/user/userInfo'], UserInfo))
  },
  // 用户登陆页面
  {
    path: '/user/login',
    component: Login => (require(['@/views/user/login'], Login))
  },
  // 用户常规注册页面
  {
    path: '/user/register',
    component: UserRegister => (require(['@/views/user/register'], UserRegister))
  },
  // 用户邮箱注册页面
  {
    path: '/user/email-register',
    component: EmailRegister => (require(['@/views/user/emailRegister'], EmailRegister))
  },
  // 用户邮箱修改
  {
    path: '/user/email-update',
    component: Emailupdate => (require(['@/views/user/emailUpdate'], Emailupdate))
  },
  // 用户忘记密码页面 forget-password
  {
    path: '/user/forget',
    component: UserForget => (require(['@/views/user/forget'], UserForget))
  },
  // 用户重置密码页面  reset-password
  {
    path: '/user/reset',
    component: Reset => (require(['@/views/user/reset'], Reset))
  }
]

export default UserAccountRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/account.js